<template>
  <div class="plat-student-outline-info"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="outlineInfo">
      <AppScrollbar style="height: 100%">
        <div class="outline-info-cont">
          <div class="group-item">
            <div class="head">
              <div class="photo">
                <el-image v-if="getPhotoLink"
                          :src="getPhotoLink"
                          fit="cover">
                </el-image>
              </div>
            </div>
            <div class="body">
              <div class="info-box">
                <span class="bold">{{outlineInfo.trueName}}</span>
                <span v-if="outlineInfo.gender">
                  <el-tag size="mini"
                          effect="dark"
                          :class="getGenderFlag">{{outlineInfo.gender.name}}</el-tag>
                </span>
                <span v-if="outlineInfo.status">
                  <el-tag size="mini"
                          effect="dark"
                          :type="getStatusType">{{outlineInfo.status.name}}</el-tag>
                </span>
              </div>
            </div>
          </div>
          <div class="group-item">
            <div class="head">
              <div class="label">
                <i class="el-icon-collection-tag"></i>
                <span>班级信息</span>
              </div>
            </div>
            <div class="body">
              <el-form size="mini"
                       label-width="80px"
                       label-suffix="：">
                <el-form-item v-if="outlineInfo.semester"
                              label="当前学期">
                  <span class="theme-text">{{outlineInfo.semester}}</span>
                </el-form-item>
                <el-form-item label="教学点">{{outlineInfo.site}}</el-form-item>
                <el-form-item label="年级">{{outlineInfo.grade}}</el-form-item>
                <el-form-item label="班级">{{outlineInfo.clazz}}</el-form-item>
                <el-form-item label="学号">{{outlineInfo.regNo}}</el-form-item>
              </el-form>
            </div>
          </div>
          <div v-if="outlineInfo.schedule"
               class="group-item">
            <div class="head">
              <div class="label schedule">
                <i class="el-icon-files"></i>
                <span>学习进程</span>
              </div>
            </div>
            <div class="body">
              <el-timeline>
                <el-timeline-item :type="outlineInfo.schedule.createDate | timeDotType">
                  <div class="schedule">
                    <div class="label">进入时间：</div>
                    <div class="value">{{outlineInfo.schedule.createDate}}</div>
                  </div>
                </el-timeline-item>
                <template v-if="outlineInfo.schedule.changes">
                  <el-timeline-item v-for="item in outlineInfo.schedule.changes"
                                    :key="item.id"
                                    :type="item.changeDate | timeDotType">
                    <div class="schedule">
                      <div class="label">{{item.changeType}}时间：</div>
                      <div class="value">{{item.changeDate}}</div>
                    </div>
                  </el-timeline-item>
                </template>
              </el-timeline>
            </div>
          </div>
        </div>
      </AppScrollbar>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <span>请求数据加载失败</span>
        <el-button type="text"
                   @click="loadOutlineInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../../../elements/AppScrollbar'
import Hint from '../../../../../../../../../elements/Hint'
export default {
  name: 'PlatStudentOutlineInfo',
  components: {
    AppScrollbar,
    Hint
  },
  props: {
    studentId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      outlineInfo: null
    }
  },
  filters: {
    timeDotType (val) {
      if (val) {
        return 'primary'
      } else {
        return 'info'
      }
    }
  },
  computed: {
    getPhotoLink () {
      const outlineInfo = this.outlineInfo
      if (outlineInfo && outlineInfo.photoLink) {
        return this.$contextPath(outlineInfo.photoLink)
      }
    },
    getGenderFlag () {
      const outlineInfo = this.outlineInfo
      if (outlineInfo && outlineInfo.gender) {
        switch (outlineInfo.gender.code) {
          case '1':
            return 'male'
          case '2':
            return 'female'
        }
      }
    },
    getStatusType () {
      const outlineInfo = this.outlineInfo
      if (outlineInfo && outlineInfo.status) {
        switch (outlineInfo.status.code) {
          case '70':
            return 'primary'
          case '80':
            return 'warning'
          default:
            return 'info'
        }
      }
    }
  },
  methods: {
    loadOutlineInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/student/info/outline',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.outlineInfo = response.data['outlineInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadOutlineInfo()
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../../../styles/color";
  .plat-student-outline-info {
    height: 100%;
    background-color: #f9f9fa;
    .outline-info-cont {
      padding: 15px;
      .group-item {
        & > .head {
          .photo {
            position: relative;
            margin: auto;
            width: 80px;
            height: 80px;
            font-size: 12px;
            text-align: center;
            line-height: 80px;
            background-color: #ecf3fe;
            border-radius: 50%;
            overflow: hidden;
            &:before {
              content: '\672a\4e0a\4f20';
              color: #909399;
            }
            .el-image {
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              .el-image__error {
                background-color: #ecf3fe;
              }
            }
          }
          .label {
            color: #606266;
            font-size: 12px;
            font-weight: bold;
            i {
              margin-left: -1px;
              margin-right: 1px;
              font-size: 13px;
              vertical-align: -1px;
            }
          }
        }
        & > .body {
          margin-top: 12px;
          padding-bottom: 10px;
          .info-box {
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            .el-tag {
              line-height: 16px;
              transform: scale(.9);
              &.male {
                background-color: #0590ff;
                border-color: #0590ff;
              }
              &.female {
                background-color: #ff40b6;
                border-color: #ff40b6;
              }
            }
            & > span {
              &.bold {
                font-weight: bold;
              }
              & + span {
                margin-left: 5px;
              }
            }
          }
          .el-form {
            .el-form-item {
              margin-bottom: 10px;
              &:last-child {
                margin-bottom: 0;
              }
              .el-form-item__label {
                color: #909399;
                font-size: 12px;
                text-align: left;
                line-height: 18px;
              }
              .el-form-item__content {
                color: #303133;
                font-size: 12px;
                line-height: 18px;
              }
            }
          }
          .el-timeline {
            margin: 15px 0 0 0;
            padding: 0 0 10px 0;
            .el-timeline-item {
              padding-bottom: 2px;
              &:last-child {
                padding-bottom: 0;
              }
              .el-timeline-item__node {
                left: 1px;
                width: 8px;
                height: 8px;
              }
              .el-timeline-item__wrapper {
                top: -5px;
                padding-left: 24px;
                padding-right: 10px;
                .el-timeline-item__content {
                  .schedule {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    & > .label {
                      color: #909399;
                      font-size: 12px;
                    }
                    & > .value {
                      color: #303133;
                      font-size: 12px;
                      white-space: nowrap;
                      &:empty {
                        &:after {
                          content: '\002f';
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        & + .group-item {
          padding-top: 15px;
          border-top: 1px solid #ebeef5;
        }
      }
    }
  }
</style>
